// extracted by mini-css-extract-plugin
export default {"steps":"styles_steps__-2366","small":"styles_small__rCasZ","line":"styles_line__+5-Py","completed":"styles_completed__JUXWA","dark":"styles_dark__EQRCZ","step":"styles_step__D2Zg2"};